import { instantsInterceptor, } from '@/api/index';

function getMenuList(requestUrl) {
    return instantsInterceptor.get('/menu/user/list?requestUrl='+requestUrl);
}

function getMgmtMenuList(useYn) {
    return instantsInterceptor.post('/mgmt/menu/list', { useYn: useYn });
}

function saveMenu(menu) {
    return instantsInterceptor.post('/mgmt/menu/save', menu);
}

function deleteMenu(menu) {
    return instantsInterceptor.post('/mgmt/menu/delete', menu);
}

function getUserMenuList(user) {
    return instantsInterceptor.post('/mgmt/menu/user/list', user);
}

function deleteUserRoleMenuList(menuList) {
    return instantsInterceptor.post('/mgmt/menu/user/role/delete', menuList);
}

function saveUserRoleMenu(menuList) {
    return instantsInterceptor.post('/mgmt/menu/user/role/save', menuList);
}

function getRoleMenuList(role) {
    return instantsInterceptor.post('/mgmt/menu/role/list', role);
}

function getManagementMenuList() {
    return instantsInterceptor.get('/mgmt/menu/management/list');
}

export {
    getMenuList,
    getMgmtMenuList,
    saveMenu,
    deleteMenu,
    getUserMenuList,
    deleteUserRoleMenuList,
    saveUserRoleMenu,
    getRoleMenuList,
    getManagementMenuList
};